import isObject from 'isobject';

/**
 * Checks if an object has a nested property
 * ex: hasNestedProps(windows, 'console')
 * ex: hasNestedProps(windows, 'console.log')
 * ex: hasNestedProps(windows, 'ArrayBuffer.apply.arguments')
 * ex: hasNestedProps(badorundefined, 'bad.child')
 * @param obj
 * @param path
 * @returns {boolean}
 */
export const hasNestedProps = function (obj, path) {
    if (!path) return false;

    const args = path.split('.');
    for (let i = 0; i < args.length; i++) {
        if (!obj || !obj.hasOwnProperty(args[i]) || !obj[args[i]]) {
            return false;
        }
        obj = obj[args[i]];
    }
    return true;
};

/**
 * Similar with the hasNestedProps but it also returns the values or null or custom default value
 * ex: getNestedProps(windows, 'console', {log: x=>x)
 * ex: getNestedProps(windows, 'console.log', x=>x)
 * ex: getNestedProps(windows, 'ArrayBuffer.apply.arguments')
 * ex: getNestedProps(badorundefined, 'bad.child','n/a')
 * @param obj
 * @param path
 * @param def
 * @returns {*}
 */
export const getNestedProps = function (obj, path, def = null) {
    if (!path) return def;

    const args = path.split('.');
    for (let i = 0; i < args.length; i++) {
        if (!obj || !obj[args[i]]) {
            return def;
        }
        obj = obj[args[i]];
    }
    return obj;
};

/**
 *  Similas with getNestedProps except that the path is given by multiple consecutive parameters
 * ex: getPathsValue(windows, x=>x, 'location','href')
 * @param obj
 * @param def
 * @param paths*
 * @returns {*}
 */
export const getPathsValue = function (obj, def, ...paths) {
    if (!paths || paths.length == 0) return def;
    const args = paths;
    for (let i = 0; i < args.length; i++) {
        if (!obj || !obj[args[i]]) {
            return def;
        }
        obj = obj[args[i]];
    }
    return obj;
};


function shuffleArray(a) {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

/*!
 * get-value <https://github.com/jonschlinkert/get-value>
 *
 * Copyright (c) 2014-2018, Jon Schlinkert.
 * Released under the MIT License.
 */

export const getValue = function (target, path, options) {
    let emptyObject = false;
    if (!isObject(options)) {
        options = { default: options };
    } else if (Object.entries(options).length === 0 && options.constructor === Object) {
		emptyObject = true;
    }

    if (!isValidObject(target)) {
        return typeof options.default !== 'undefined' ? options.default : target;
    }

    if (typeof path === 'number') {
        path = String(path);
    }

    const isArray = Array.isArray(path);
    const isString = typeof path === 'string';
    const splitChar = options.separator || '.';
    const joinChar = options.joinChar || (typeof splitChar === 'string' ? splitChar : '.');

    if (!isString && !isArray) {
        return target;
    }

    if (isString && path in target) {
        return isValid(path, target, options) ? target[path] : options.default;
    }

    const segs = isArray ? path : split(path, splitChar, options);
    const len = segs.length;
    let idx = 0;

    do {
        let prop = segs[idx];
        if (typeof prop === 'number') {
            prop = String(prop);
        }

        while (prop && prop.slice(-1) === '\\') {
            prop = join([prop.slice(0, -1), segs[++idx] || ''], joinChar, options);
        }

        if (prop in target) {
            if (!isValid(prop, target, options)) {
                return options.default;
            }

            target = target[prop];
        } else {
            let hasProp = false;
            let n = idx + 1;

            while (n < len) {
                prop = join([prop, segs[n++]], joinChar, options);

                if ((hasProp = prop in target)) {
                    if (!isValid(prop, target, options)) {
                        return options.default;
                    }

                    target = target[prop];
                    idx = n - 1;
                    break;
                }
            }

            if (!hasProp) {
                return emptyObject ? {} : options.default;
            }
        }
    } while (++idx < len && isValidObject(target));

    if (idx === len) {
        return target;
    }

    return options.default;
};

function join(segs, joinChar, options) {
    if (typeof options.join === 'function') {
        return options.join(segs);
    }
    return segs[0] + joinChar + segs[1];
}

function split(path, splitChar, options) {
    if (typeof options.split === 'function') {
        return options.split(path);
    }
    return path.split(splitChar);
}

function isValid(key, target, options) {
    if (typeof options.isValid === 'function') {
        return options.isValid(key, target);
    }
    return true;
}

function isValidObject(val) {
    return isObject(val) || Array.isArray(val) || typeof val === 'function';
}

export const param = function (obj) {
    if (isValidObject(obj)) {
		return Object.keys(obj).map(function(k) {
			return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k])
		}).join('&');
    }
};
